import { useState } from "react";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import { ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { getDarkDropdown } from "../../../../Utils/otherFunctions";
import { Link } from "react-router-dom";
import { useThemeContext } from "../../../../Context/ThemeContext";
import DeleteCapaianIK from "../components/DeleteCapaianIK";
import ModalDetailCapaianIK from "../components/ModalDetailCapaianIK";
import HighlightedCell from "../components/HighlightedCell";
import { FEATURE_FUNCTION_SELECTION } from "../../../../Constant/FeatureSelection";

const DaftarCapaianIKColumns = (capaianIK, axiosInstance, filterText) => {
  const [detailOpen, setDetailOpen] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(null);
  const { themeContext } = useThemeContext();

  const [selectedCapaian, setSelectedCapaian] = useState([]);

  const toggleDetailOpen = (row) => {
    setDetailOpen(detailOpen === row.id ? null : row.id);
    if (detailOpen !== row.id) {
      setSelectedCapaian(row);
    } else {
      setSelectedCapaian([]);
    }
  };

  const toggleDeleteOpen = (row) => {
    setDeleteOpen(deleteOpen === row.id ? null : row.id);
    if (detailOpen !== row.id) {
      setSelectedCapaian(row);
    } else {
      setSelectedCapaian([]);
    }
  };

  const columns = [
    {
      name: <DataTableTitle text={"Unit Kerja"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.unit_kerja.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.unit_kerja}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Perspektif"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.perspektif.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.perspektif}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Kode SS"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.kode_ss.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.kode_ss}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Sasaran Strategis"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.nama_ss.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.nama_ss}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Kode IK"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.kode_ik.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.kode_ik}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Indikator Kinerja"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.nama_ik.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.nama_ik}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Polarisasi"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.polarisasi.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.polarisasi}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tipe Konsolidasi"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.tipe_konsolidasi.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.tipe_konsolidasi}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Satuan"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.satuan_capaian.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.satuan_capaian}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Bobot Indikator Kinerja"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.bobot_ik.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.bobot_ik}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <div>
          <ButtonGroup>
            {/* <UncontrolledDropdown direction="up"> */}
            <UncontrolledDropdown>
              <DropdownToggle caret></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  className={getDarkDropdown(themeContext)}
                  onClick={() => {
                    toggleDetailOpen(row);
                  }}
                >
                  Lihat Detail
                </DropdownItem>
                <DropdownItem divider />
                <Link
                  to={`${process.env.PUBLIC_URL}/capaianik/editcapaianik/${row.id}`}
                >
                  <DropdownItem className={getDarkDropdown(themeContext)}>
                    Ubah
                  </DropdownItem>
                </Link>
                <DropdownItem divider />
                <DropdownItem
                  className={getDarkDropdown(themeContext)}
                  onClick={() => toggleDeleteOpen(row)}
                  disabled={FEATURE_FUNCTION_SELECTION.CapaianIK.Delete}
                >
                  Hapus
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </ButtonGroup>
          <DeleteCapaianIK
            deleteModalOpen={deleteOpen === row.id}
            toggleDeleteModal={toggleDeleteOpen}
            selectedCapaian={selectedCapaian}
            getCapaianIK={capaianIK}
            axiosInstance={axiosInstance}
          />
          <ModalDetailCapaianIK
            rincianModalOpen={detailOpen === row.id}
            toggleRincianModal={toggleDetailOpen}
            selectedCapaian={selectedCapaian}
          />
        </div>
      ),
    },
  ];

  return columns;
};

export default DaftarCapaianIKColumns;
